import React from 'react'
import Nosotroscard from '../components/nosotros/nosotrosCard'

const Nosotros = () => {
  return (
    <div>
        
        <Nosotroscard/>
    </div>
  )
}

export default Nosotros